import {
  GET_EVENT,
  GET_PERFORMANCE_REVIEW,
  GET_EMPLOYEE_APPARAISAL,
  VIEW_EMPLOYEE_APPARAISAL,
} from "../../actionTypes";

const initialState = {
  events: [],
  performanceReview: [],
  yetToAppraised: [],
  appraised: [],
  viewEmployeeAppraisal: {},
};

export const performanceMngtReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_EVENT:
      return {
        ...state,
        events: payload.data,
      };

    case GET_PERFORMANCE_REVIEW:
      return {
        ...state,
        performanceReview: payload,
      };

    case GET_EMPLOYEE_APPARAISAL:
      return {
        ...state,
        yetToAppraised: payload.data.employees_for_review,
        appraised: payload.data.employees_to_review,
      };

    case VIEW_EMPLOYEE_APPARAISAL:
      return {
        ...state,
        viewEmployeeAppraisal: payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/actions/performancemanagement/performance.reducer.js